import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { getOrders } from "../../redux/actions/orderAction";

export default function Index() {
    const history = useHistory();
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getOrders());
    }, [dispatch]);

    let { orders } = useSelector((state) => state.order);

    const [search, setSearch] = useState("");

    const getFilteredData = (data, search) => {
        if (search.length) {
            data = data.filter(
                (item) =>
                    item?.id?.includes(search.toLowerCase())
                    || item?.personalInfo?.fullName?.toLowerCase()?.includes(search.toLowerCase())
                    || item?.personalInfo?.email?.toLowerCase()?.includes(search.toLowerCase())
                    || item?.projectName?.toLowerCase()?.includes(search.toLowerCase())

            );
        }
        return data;
    };

    orders = getFilteredData(orders, search);

    // const onDelete = (e, id) => {
    //     confirmPopup({
    //         target: e.currentTarget,
    //         message: "Are you sure you want to delete this service? This action will permanently delete the user account. This action cannot be undone.",
    //         icon: "pi pi-exclamation-triangle",
    //         accept: () => dispatch(deleteService(id)),
    //         reject: () => { },
    //     });
    // };

    return {
        orders,
        history,
        search,
        setSearch,
        dispatch
    };
}
